var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 128,
    viewBox: "0 0 142 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1333 122.733C72.8667 123.533 69.1333 123.533 66.8667 122.733C47.5333 116.133 4.33334 88.5998 4.33334 41.9332C4.33334 21.3332 20.9333 4.6665 41.4 4.6665C53.5333 4.6665 64.2667 10.5332 71 19.5998C77.7333 10.5332 88.5334 4.6665 100.6 4.6665C121.067 4.6665 137.667 21.3332 137.667 41.9332C137.667 88.5998 94.4667 116.133 75.1333 122.733Z",
    stroke: "#2F2F2F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGrey);
export default __webpack_public_path__ + "static/media/heart-grey.241567428c5595701273c0d39c0e634d.svg";
export { ForwardRef as ReactComponent };